<table class="table__wrapper">
	<thead>
		<tr class="header__wrapper">
			<th class="header__text pl-8">
				<button class="flex flex-row" (click)="toggleSort()">
					Id
					@if (sortDirection === 'desc') {
						<activar-icon name="arrow_down"> </activar-icon>
					} @else {
						<activar-icon name="arrow_up"> </activar-icon>
					}
				</button>
			</th>
			<th class="header__text">Asegurado</th>
			<th class="header__text">Dirección</th>
			<th class="header__text">Documento</th>
			<th class="header__text">Fecha de nacimiento</th>
			@if (canShowProducer && !hasAgentsFilter()) {
				<th class="header__text">Productor</th>
			}
			<th class="header__text text-center">Estado</th>
			<th class="header__text px-8"></th>
		</tr>
	</thead>

	<tbody>
		@for (row of rows(); track row.id; let i = $index) {
			<tr
				class="body__wrapper"
				[ngClass]="i % 2 === 0 ? 'bg-gray-50' : 'bg-white'">
				<td class="id__cell text-gray-600">
					{{ row.internalNumber }}
				</td>
				<td>
					<activar-user-badge
						[firstName]="row.firstName"
						[lastName]="row.lastName"
						[email]="row.email"
						[companyName]="row.companyName" />
				</td>
				<td>
					<div class="ellipsis">
						{{ row.address }}
					</div>
				</td>
				<td class="whitespace-nowrap">
					{{ formatIdentification(row) }}
				</td>
				<td>
					{{
						row.birthDate
							? (row.birthDate | date: 'dd/MM/yyyy')
							: '-'
					}}
				</td>
				@if (canShowProducer  && !hasAgentsFilter()) {
					<td class="">
						@if (isUserType(row.agent.user.type, USER_TYPES.COMPANY)) {
							{{ row.agent.user.companyName || '-' }}
						} @else {
							{{ row.agent.user.firstName || '-' }}
							{{ row.agent.user.lastName || '' }}
						}
					</td>
				}
				<td class="flex justify-center items-center h-20">
					<activar-badge
						class="flex justify-center"
						[text]="row.badgeText"
						[status]="row.badgeStatus" />
				</td>

				<td class="text-center">
					<a
						[routerLink]="['/usuarios', row.id]"
						class="text-primary-600 font-semibold">
						Ver
					</a>
				</td>
			</tr>
		} @empty {
			<tr class="body__wrapper">
				<td class="my-5" colspan="7">
					<div
						class="flex flex-col items-center justify-center text-center w-full my-5">
						<div class="mb-8">
							No se encontraron usuarios para mostrar.
						</div>
						<img src="empty_list.svg" alt="empty" />
					</div>
				</td>
			</tr>
		}
	</tbody>
</table>
